import React, {useEffect} from 'react';

const AGB = () => {
  useEffect(() => {
    const wrapper = document.querySelector('.scrollable');
    if (!wrapper) return;

    document.querySelector('.scrollable').addEventListener(
      'touchmove',
      function(event) {
        event.stopPropagation();
      },
      false,
    );
  });

  return (
    <>
      <div className="scrollable">
        <div className="profile-dataprotection">
          <div className="profile-text-container">
            <div className="profile-text-item">
            § 1 Geltungsbereich/Allgemeines (1) Die vorliegenden Allgemeinen Geschäftsbedingungen (AGB) gelten nur gegenüber Unternehmern i.S.v. § 14 BGB (nachfolgend: „Kunde“).
            </div>
            <div className="profile-text-item">
            (2) Es gelten ausschließlich die AGB der IQVIA Commercial GmbH & Co. OHG. Abweichende, entgegenstehende oder ergänzende Allgemeine Geschäftsbedingungen des Kunden werden nur dann und insoweit Vertragsbestandteil, als Aposphäre GmbH ihrer Geltung ausdrücklich zugestimmt hat. Dieses Zustimmungserfordernis gilt in jedem Fall, beispielsweise auch dann, wenn IQVIA Commercial GmbH & Co. OHG in Kenntnis der AGB des Kunden die Lieferung an ihn vorbehaltlos ausführt.
            </div>
            <div className="profile-text-item">
            (3) Im Einzelfall getroffene, individuelle Vereinbarungen mit dem Kunden (einschließlich Nebenabreden, Ergänzungen und Änderungen) haben in jedem Fall Vorrang vor diesen AGB. Für den Inhalt derartiger Vereinbarungen ist ein schriftlicher Vertrag bzw. die schriftliche Bestätigung durch IQVIA Commercial GmbH & Co. OHG maßgebend.
            </div>
            <div className="profile-text-item">
            § 2 Angebote
            </div>
            <div className="profile-text-item">
            (1) Angebote der IQVIA Commercial GmbH & Co. OHG sind vorbehaltlich einer anders lautenden Vereinbarung stets freibleibend.
            </div>
            <div className="profile-text-item">
            (2) Kosten für honorarpflichtige Bildmotive sind vorab nicht abzuschätzen und daher in den Angeboten von Aposphäre GmbH nicht enthalten. Sie werden gegebenenfalls in einer gesonderten Bestätigung ausgewiesen und gesondert abgerechnet.
            </div>
            <div className="profile-text-item">
            (3) Die Erbringung von rechtlichen oder steuerlichen Beratungsleistungen durch die IQVIA Commercial GmbH & Co. OHG ist ausnahmslos ausgeschlossen. Für die Frage der rechtlichen, insbesondere werblichen Zulässigkeit einer zu erbringenden Dienstleistung ist ausschließlich der Kunde verantwortlich.
            </div>
            <div className="profile-text-item">
            § 3 Lieferung
            </div>
            <div className="profile-text-item">
            (1) Liefertermine/Lieferzeiten sind vorbehaltlich einer anders lautenden Vereinbarung stets unverbindlich.
            </div>
            <div className="profile-text-item">
            (2) Liefertermine/Lieferzeiten hängen davon ab, dass die der Kunden etwaigen Mitwirkungspflichten unverzüglich nachkommt, der Kunde die Lieferung rechtzeitig freigibt und IQVIA Commercial GmbH & Co. OHG seinerseits rechtzeitig von Subunternehmern oder mitwirkenden Unternehmern beliefert wird. Sofern eine Freigabe nicht erforderlich ist, tritt an deren Stelle das Datum des Zugangs der Auftragsbestätigung beim Kunden.
            </div>
            <div className="profile-text-item">
            § 4 Gefahrübergang, Preise
            </div>
            <div className="profile-text-item">
            (1) Vorbehaltlich einer anders lautenden Vereinbarung gelten Lieferungen und Preise stets „ab Werk“. Der Versand erfolgt auf Gefahr des Kunden. Auf Wunsch des Kunden wird IQVIA Commercial GmbH & Co. OHG  die Lieferung durch eine Transportversicherung eindecken; die insoweit anfallenden Kosten trägt der Kunde. Dies gilt auch für die Rücksendung vom Kunden zur Verfügung gestellter Materialien.
            </div>
            <div className="profile-text-item">
            (2) Preise verstehen sich ausschließlich Verpackung; diese wird gesondert zum Selbstkostenpreis in Rechnung gestellt. Liefer- und Versandkosten werden nach Aufwandgesondert berechnet.
            </div>
            <div className="profile-text-item">
            (3) Beträge sind, wenn nicht ausdrücklich anders angegeben, in Euro angegeben und auch ausschließlich in Euro zahlbar.
            </div>
            <div className="profile-text-item">
            (4) Die gesetzliche Mehrwertsteuer ist nicht in den Preisen eingeschlossen; sie wird in gesetzlicher Höhe am Tag der Rechnungsstellung in der Rechnung gesondert ausgewiesen.
            </div>
            <div className="profile-text-item">
            (5) IQVIA Commercial GmbH & Co. OHG behält sich das Recht vor, die Preise entsprechend zu ändern, wenn nach Abschluss des Vertrages Kostensenkungen oder Kostenerhöhungen, insbesondere aufgrund von Tarifabschlüssen oder Materialpreisänderungen, eintreten. Diese wird IQVIA Commercial GmbH & Co. OHG dem Besteller auf Verlangen nachweisen.
            </div>
            <div className="profile-text-item">
            (6) Führen Kursschwankungen ausländischer Währungen von über 5 % zu einer Steigerung der Beschaffungskosten, ist IQVIA Commercial GmbH & Co. OHG  berechtigt, den Preis angemessen zu erhöhen IQVIA Commercial GmbH & Co. OHG hat die Kursschwankungen nachzuweisen.
            </div>
            <div className="profile-text-item">
            (7) Reisekosten und Reisezeiten werden vorbehaltlich einer anders lautenden Vereinbarung zusätzlich mit 0,70 Euro pro Straßenkilometer und mit 70,00 Euro pro Stunde und Person berechnet.
            </div>
            <div className="profile-text-item">
            (8) Entwurfsarbeiten sind, da sie ein künstlerisches Werk darstellen, ohne Rücksicht auf Gefallen oder Nichtgefallen zu vergüten.
            </div>
            <div className="profile-text-item">
            § 5 Zahlungsbedingungen
            </div>
            <div className="profile-text-item">
            (1) Rechnungsbeträge werden, sofern nicht schriftlich anders vereinbart, nach 8 Kalendertagen fällig.
            </div>
            <div className="profile-text-item">
            (2) Bei Dienst- oder Werkleistungen werden bei Projektstart 40 % der Gesamtauftragssumme in Rechnung gestellt.
            </div>
            <div className="profile-text-item">
            (3) Ferner werden im Rahmen des Auftragsfortschritts von IQVIA Commercial GmbH & Co. OHG angemessene Abschlagsrechnungen gestellt, deren Bezahlung innerhalb von 8 Arbeitstagen zur Zahlung fällig wird. Die geleisteten Abschlagszahlungen werden von der Schlussrechnung abgezogen.
            </div>
            <div className="profile-text-item">
            (4) Zahlungen mittels Wechsel werden nicht anerkannt. 
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default AGB;
